define(["underscore","jquery"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__32__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__32__;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(57);


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PerformanceTimingLogger", {
  enumerable: true,
  get: function get() {
    return _index.PerformanceTimingLogger;
  }
});

var _index = __webpack_require__(58);

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PerformanceTimingLogger = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(32));

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create an instance of Performance Timing Logger
 */
class PerformanceTimingLogger {
  constructor(options = {}) {
    this.instrumentation = options.instrumentation;
    this.updateInterval = options.updateInterval || 2500;
  }
  /**
   * init performance timing logging
   * @returns {undefined} - no returns
   */


  init() {
    if (!_underscore.default.isFunction(window.performance.getEntriesByType)) {
      return;
    }

    this.isPageLoaded = false;
    this.pageNavLogged = false;

    if (document.readyState === 'complete') {
      this.logOnLoad();
    } else {
      (0, _jquery.default)(window).on('load', () => this.logOnLoad());
    }

    this.timer = setInterval(() => this.logOnTimer(), this.updateInterval);

    this.instrumentation.beforeStop = () => {
      this.logOnUnload();
    };
  }
  /**
   * @private
   * @returns {undefined} - no returns
   */


  logOnLoad() {
    this.writeResourceTimingLogs();
    this.tryRecordInactiveTime();
    this.tryLogPageNavigation();
    this.isPageLoaded = true;
  }
  /**
   * @private
   * @returns {undefined} - no returns
   */


  logOnTimer() {
    this.writeResourceTimingLogs();
    this.tryLogPageNavigation();
  }
  /**
   * @private
   * @returns {undefined} - no returns
   */


  logOnUnload() {
    this.writeResourceTimingLogs();
  }
  /**
   * writes resource timing logs
   * @private
   * @returns {undefined} - no returns
   */


  writeResourceTimingLogs() {
    const logs = window.performance.getEntriesByType('resource');
    this.clearLogBuffer();

    if (!logs.length) {
      return;
    }

    _underscore.default.each(logs, log => {
      _underscore.default.extend(log, {
        pageLoaded: this.isPageLoaded
      });

      this.instrumentation.writeRawLog(log);
    });
  }
  /**
   * If supported, record the amount of time the page was in the background.
   * It gets the foreground time from window.performance.activeTime
   * @private
   * @returns {undefined} - no returns
   */


  tryRecordInactiveTime() {
    if (_underscore.default.isFunction(window.performance.activeTime)) {
      this.inactiveTime = window.performance.now() - window.performance.activeTime();
    }
  }
  /**
   * try log page navigation logs
   * @private
   * @returns {bool} - if page navigation has been logged
   */


  tryLogPageNavigation() {
    if (!this.pageNavLogged && window.performance.timing && window.performance.timing.loadEventEnd > 0) {
      this.pageNavLogged = this.writePageNavigationLogs();
    }

    return this.pageNavLogged;
  }
  /**
   * writes page navigation logs
   * @private
   * @returns {bool} - if page navigation has been logged
   */


  writePageNavigationLogs() {
    const extensions = {
      isPageNavigationLog: true
    };

    if (window.chrome && _underscore.default.isFunction(window.chrome.loadTimes)) {
      const _ref = window.chrome.loadTimes() || {},
            firstPaintTime = _ref.firstPaintTime;

      if (_underscore.default.isNumber(firstPaintTime) && firstPaintTime > 0) {
        extensions.firstPaintTime = firstPaintTime * 1000;
      } else {
        return false;
      }
    }

    const navTimingV2Logs = window.performance.getEntriesByType('navigation');

    if (_underscore.default.isArray(navTimingV2Logs) && _underscore.default.size(navTimingV2Logs) > 0) {
      const navTimingV2Log = _underscore.default.first(navTimingV2Logs);

      const colsToReplace = _underscore.default.pick(navTimingV2Log, 'unloadEventStart', 'unloadEventEnd', 'redirectCount', 'redirectStart', 'redirectEnd');

      _underscore.default.extend(extensions, colsToReplace);
    } else {
      extensions.redirectCount = window.performance.navigation.redirectCount;
    }

    if (this.inactiveTime) {
      extensions.inactiveTime = this.inactiveTime;
    }

    this.instrumentation.writeRawLog(_underscore.default.extend({}, window.performance.timing, extensions));
    return true;
  }
  /**
   * @private
   * @returns {undefined} - no returns
   */


  clearLogBuffer() {
    if (_underscore.default.isFunction(window.performance.clearResourceTimings)) {
      window.performance.clearResourceTimings();
    } else if (_underscore.default.isFunction(window.performance.webkitClearResourceTimings)) {
      window.performance.webkitClearResourceTimings();
    }
  }

}

exports.PerformanceTimingLogger = PerformanceTimingLogger;

/***/ })

/******/ })});;
